var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutUs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666504 13.3333V12.6667C0.666504 10.0893 2.75584 8 5.33317 8M9.99984 13.3333V12.6667C9.99984 10.0893 7.9105 8 5.33317 8M5.33317 8C6.80593 8 7.99984 6.80609 7.99984 5.33333C7.99984 3.86057 6.80593 2.66667 5.33317 2.66667C3.86041 2.66667 2.6665 3.86057 2.6665 5.33333C2.6665 6.80609 3.86041 8 5.33317 8ZM15.3332 9.66667V9.33333C15.3332 7.49238 13.8408 6 11.9998 6M11.9998 6C10.1589 6 8.6665 7.49238 8.6665 9.33333M11.9998 6C13.1044 6 13.9998 5.10457 13.9998 4C13.9998 2.89543 13.1044 2 11.9998 2C10.8953 2 9.99984 2.89543 9.99984 4C9.99984 5.10457 10.8953 6 11.9998 6Z",
    stroke: "#1E1E1E",
    strokeOpacity: 0.87,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUs);
export default __webpack_public_path__ + "static/media/about-us.e959f0140f40d6cbe35582efb4ec0602.svg";
export { ForwardRef as ReactComponent };